<template>
	<div>
		<div class="row">
			<div class="col-12">
				<alert-success :class="'d-block shadow-sm'" :form="form" message="Fee updated successfully."></alert-success>
			</div>
		</div>

        <div v-if="loading">
            <spinner-component :loading="loading"/>
        </div>

        <div v-if="error" class="error">
			{{ error }}
        </div>

        <div v-if="fee">
            <div class="d-flex align-items-center justify-content-between mg-b-25">
                <h3 class="df-title">Manage Fees</h3>
                <div class="d-flex">
                    <router-link class="btn btn-sm pd-x-15 btn-white shadow-sm mg-l-5" :to="{ name: 'fees.manage' }">Go Back</router-link>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                        <div class="media">
                            <!-- <div class="wd-40 wd-md-50 ht-40 ht-md-50 tx-white mg-r-10 d-flex align-items-center justify-content-center rounded" :class="feeType(fee.type, false, true)" v-html="feeType(fee.type, true)"></div> -->
                            <div class="media-body">
                                <!-- <h5 class="mg-t-5 mg-b-0 tx-spacing--1" v-html="feeType(fee.type)"></h5> -->
                                <p class="tx-12 tx-medium tx-spacing-1 tx-color-03">Last Update: {{ fee.updated_at|toDate('D MMM, YYYY, h:mm a') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h6 class="mg-b-20">Fee Info</h6>
            <div class="row">
				<div class="col-md-12">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Amount</label>
					<p class="mg-b-0">{{ fee.amount|toCurrency(fee.currency) }}</p>
				</div>
				<div class="col-md-12 mg-t-20 mg-sm-t-30">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Date</label>
					<p class="mg-b-0">{{ fee.date|toDate('D MMM, YYYY, h:mm a')|placeholder }}</p>
				</div>
                <div class="col-md-12 mg-t-20 mg-sm-t-30">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Portfolio</label>
					<p class="mg-b-0">
						{{ fee.external_portfolio_id|placeholder }}
						<router-link class="ml-3 text-small" :to="{ name: 'portfolios.show', params: { portfolio: fee.external_portfolio_id } }">Manage</router-link>
					</p>
				</div>
				<div class="col-md-4 mg-t-20 mg-sm-t-30">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Status</label>
					<div v-html="feeStatus(fee.status)"></div>
				</div>
				<div v-if="fee.status === 'processed'" class="col-md-4 mg-t-20 mg-sm-t-30">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Transaction</label>
					<p class="mg-b-0">
						<router-link class="text-small" :to="{ name: 'transactions.show', params: { id: fee.transaction } }">View Transaction</router-link>
					</p>
				</div>
			</div>

            

			<!-- <div class="modal" id="updateFee" tabindex="-1" role="dialog" aria-hidden="true">
				<div class="modal-dialog modal-sm" role="document">
					<form class="modal-content" @submit.prevent="updateFee">
						<div class="modal-header">
							<h5 class="modal-title"></h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<p class="mg-b-0"></p>
						</div>
						<div class="modal-footer">
							<div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
								<button-component :busy="form.busy" :label="label" :label-loading="'Please wait...'" :button-class="buttonClass"></button-component>
								<button type="button" data-dismiss="modal" class="btn btn-primary shadow-sm mg-sm-l-5">Cancel</button>
							</div>
						</div>
					</form>
				</div>
			</div> -->
        </div>
    </div>
</template>

<script>
	export default {
		mounted() {},
		data() {
			return {
				refresh: false,
				loading: false,
				fee: null,
				error: null,
				label: null,
				buttonClass: null,
				form: new Form({
					status: null
				})
			};
		},
		created() {
			this.fetchFee();
		},
		updated() {
			feather.replace();
		},
		watch: {
			$route: "fetchFee",
			refresh: function(status) {
				if (status) {
					this.fetchFee();
				}
			}
		},
		methods: {
			fetchFee() {
				this.error = this.fee = null;
				this.loading = true;

				axios
					.get(`/api/fees/${this.$route.params.id}`)
					.then(response => {
						const fee = response.data.data.fees;

						if (!_.isEmpty(fee)) {
							this.fee = fee;
						}
					})
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = this.refresh = false;

						// $("#updateFee").on("show.bs.modal", event => {
						// 	const fee = $(event.relatedTarget);
						// 	const type = _.startCase(fee.data("type"));
						// 	const modal = $("#updateFee");

						// 	modal.find(".modal-title").text(`${type} Fee`);
						// 	modal
						// 		.find(".modal-body p")
						// 		.text(
						// 			`Do you really want to ${fee.data(
						// 				"type"
						// 			)} this client's fee?`
						// 		);
						// 	this.label = `${type} fee`;
						// 	this.buttonClass =
						// 		fee.data("type") === "approve"
						// 			? "btn btn-success shadow-sm mg-b-5 mg-sm-b-0"
						// 			: "btn btn-danger shadow-sm mg-b-5 mg-sm-b-0";
						// 	this.form.status = fee.data("action");
						// });

						// $("#updateFee").on("hidden.bs.modal", e => {
						// 	this.form.status = null;
						// });
					});
			}
			// updateFee() {
			// 	this.form
			// 		.patch(`/api/fees/${this.$route.params.id}`)
			// 		.then(({ data }) => {
			// 			$("#updateFee").modal("hide");
			// 			this.refresh = true;
			// 		});
			// }
		}
	};
</script>